'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    // # IMPORTANT
    // When pasting the svg, don't forget to set the viewBox.
    //
    _class.prototype.render = function render() {
        var rotate = this.props.rotate === true ? 180 : this.props.rotate;

        return _react2.default.createElement(
            'svg',
            { width: this.props.width + 'px',
                height: this.props.height + 'px'
                //fill={this.props.color}
                , style: { transform: 'rotate(' + rotate + 'deg)' },
                viewBox: '0 0 12 22' },
            _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M 11.43 3.31C 11.43 3.31 4.28 10.97 4.28 10.97 4.28 10.97 11.48 18.68 11.48 18.68 12.19 19.44 12.19 20.67 11.48 21.43 10.78 22.18 9.63 22.18 8.92 21.43 8.92 21.43 0.59 12.51 0.59 12.51 0.07 11.96-0.06 11.17 0.16 10.49 0.22 10.09 0.38 9.72 0.66 9.41 0.66 9.41 8.9 0.6 8.9 0.6 9.6-0.15 10.73-0.15 11.43 0.6 12.13 1.35 12.13 2.56 11.43 3.31Z' })
        );
    };

    return _class;
}(_react2.default.Component);

_class.defaultProps = {
    width: 12,
    height: 14,
    color: 'rgb(255,255,255)',
    rotate: false
};
exports.default = _class;